import { render, staticRenderFns } from "./ClientRecommerce.vue?vue&type=template&id=0364d990"
import script from "./ClientRecommerce.vue?vue&type=script&lang=js"
export * from "./ClientRecommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports